import { Pipe } from '@angular/core';
var ItemPipe = /** @class */ (function () {
    function ItemPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ItemPipe.prototype.transform = function (value) {
        // ES6 array destructuring
        return value.filter(function (item) { return item.matchFilter; });
    };
    ItemPipe.decorators = [
        { type: Pipe, args: [{ name: 'itemPipe' },] },
    ];
    /**
     * @nocollapse
     */
    ItemPipe.ctorParameters = function () { return []; };
    return ItemPipe;
}());
export { ItemPipe };
function ItemPipe_tsickle_Closure_declarations() {
    /** @type {?} */
    ItemPipe.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ItemPipe.ctorParameters;
}
//# sourceMappingURL=item.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/pipes/item.pipe.js
// module id = 165
// module chunks = 0